import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery, useQueryClient } from 'react-query';

import { GiftCardEditorForm } from 'features/my-gift-cards/components/GiftCardEditorForm';
import { IdType } from 'ts/IdType';
import { getFullGiftCardRequest } from 'features/my-gift-cards/api';
import { Loaders } from 'shared';

interface GiftCardEditorPageProps {}

interface GiftCardEditorRouteParams {
  cardId: IdType;
}

const genGiftCardQueryKey = (cardId: IdType) => `my-gift-cards/${cardId}`;

export const GiftCardEditorPage: React.FC<GiftCardEditorPageProps> = () => {
  const { cardId } = useParams<GiftCardEditorRouteParams>();
  const { isFetching, data } = useQuery(
    genGiftCardQueryKey(cardId),
    async () => {
      const { data } = await getFullGiftCardRequest(cardId);
      return data;
    },
    {
      staleTime: Infinity,
      enabled: cardId !== 'new',
    }
  );

  const queryClient = useQueryClient();

  const invalidateQuery = React.useCallback(() => {
    queryClient.invalidateQueries(genGiftCardQueryKey(cardId));
  }, [cardId, queryClient]);

  if (isFetching) {
    return <Loaders.Loader />;
  }

  return <GiftCardEditorForm card={data} invalidateQuery={invalidateQuery} />;
};
